import { action, observable, set } from 'mobx';
import { IStoresDirectoryItem } from '../../../api/Interfaces';
import { Address } from './Address';

export class StoresDirectoryItem {
    @observable public id: string;
    @observable public address: Address;
    @observable public name: string;
    @observable public storeUrl: string;

    public static fromJson(data: IStoresDirectoryItem): StoresDirectoryItem {
        const store = new StoresDirectoryItem();
        set(store, data);

        const { address, store_url } = data;

        store.address = Address.fromJSON(address);
        store.storeUrl = store_url;

        return store;
    }

    @action
    public update(data: Partial<IStoresDirectoryItem>) {
        set(this, data);
    }
}
